// src/modules/time-tracking/MyShiftDetail.js (employee self portal)
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import EmployeeLayout from '../../layouts/EmployeeLayout';
import LoadingSpinner from '../../components/shared/LoadingSpinner';
import { FormHeader, BackButton } from '../../components/styled/FormComponents';
import { getMyShift } from './timeTrackingService';
import ShiftView from './components/ShiftView';

const MyShiftDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getMyShift(id)
      .then(setDetail)
      .catch(() => setError('Failed to load shift.'))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <EmployeeLayout title="My Time">
      <FormHeader>
        <BackButton onClick={() => navigate('/my-time')}><FaArrowLeft /> Back</BackButton>
        <h2>Shift</h2>
      </FormHeader>
      {loading ? <LoadingSpinner /> : error ? <p style={{ color: '#FF5252' }}>{error}</p> : <ShiftView detail={detail} />}
    </EmployeeLayout>
  );
};

export default MyShiftDetail;
